// src/pinball/components/PinballHUD.tsx - Score, ball count, multipliers display

import React from 'react';
import { PinballGameState } from '../types';
import './PinballHUD.css';

interface PinballHUDProps {
  state: PinballGameState;
  highScore: number;
}

export const PinballHUD: React.FC<PinballHUDProps> = ({ state, highScore }) => {
  const ballSaveRemaining = state.ballSaveActive
    ? Math.max(0, Math.ceil((state.ballSaveExpiry - Date.now()) / 1000))
    : 0;

  const isNewHighScore = state.score > highScore && highScore > 0;

  return (
    <div className="pinball-hud" data-testid="pinball-hud">
      <div className="hud-score-section">
        <div className="hud-score" data-testid="pinball-score">
          <span className="hud-label">SCORE</span>
          <span className="hud-value">{state.score.toLocaleString()}</span>
        </div>
        {isNewHighScore && (
          <div className="hud-new-high-score">NEW HIGH SCORE!</div>
        )}
        <div className="hud-high-score">
          <span className="hud-label">HIGH</span>
          <span className="hud-value-small">{highScore.toLocaleString()}</span>
        </div>
      </div>

      <div className="hud-info-section">
        <div className="hud-ball" data-testid="pinball-ball-count">
          <span className="hud-label">BALL</span>
          <span className="hud-value">{state.currentBallNumber} / {state.totalBalls}</span>
        </div>

        <div className="hud-multiplier">
          <span className="hud-label">MULTI</span>
          <span className="hud-value">{state.scoreMultiplier}x</span>
        </div>

        <div className="hud-bonus">
          <span className="hud-label">BONUS</span>
          <span className="hud-value">{state.bonusMultiplier}x</span>
        </div>
      </div>

      <div className="hud-indicators">
        {state.ballSaveActive && (
          <div className="hud-indicator ball-save" data-testid="ball-save-indicator">
            BALL SAVE {ballSaveRemaining}s
          </div>
        )}

        {state.multiballActive && (
          <div className="hud-indicator multiball" data-testid="multiball-indicator">
            MULTIBALL
          </div>
        )}

        {state.tiltWarnings === 1 && (
          <div className="hud-indicator tilt-warning">DANGER</div>
        )}

        {state.tilted && (
          <div className="hud-indicator tilt">TILT</div>
        )}

        {state.comboCount > 1 && (
          <div className="hud-indicator combo">
            COMBO x{state.comboCount}
          </div>
        )}
      </div>
    </div>
  );
};
